(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cbd-navigation"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cbd-category-navigation')) {
  customElements.define('cbd-category-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const details = this.querySelector('details');
      this.addEventListener('click', (event) => {
        if (event.target.closest('a')) details.open = false;
      }, options);
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && details.open) {
          details.open = false;
          details.querySelector('summary').focus();
          event.stopPropagation();
        }
      }, options);
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) details.open = false;
      }, options);
      this.addEventListener('shopify:block:select', () => { details.open = true; }, options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cbd-selection"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('cbd-product-finder')) {
  class CbdProductFinder extends HTMLElement {
    connectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.form = this.querySelector('[data-filters]');
      this.cards = Array.from(this.querySelectorAll('[data-card]'));
      this.groups = Array.from(this.querySelectorAll('[data-group]'));
      this.form.hidden = false;
      this.form.addEventListener('submit', (event) => event.preventDefault(), options);
      this.form.addEventListener('input', (event) => {
        if (event.target.name === 'category') { this.refreshKinds(); this.updateCategoryUrl(); }
        this.applyFilters();
      }, options);
      this.form.addEventListener('change', (event) => {
        if (event.target.name === 'category') { this.refreshKinds(); this.updateCategoryUrl(); }
        this.applyFilters();
      }, options);
      this.form.addEventListener('reset', () => {
        queueMicrotask(() => { this.refreshKinds(); this.applyFilters(); this.updateCategoryUrl(); });
      }, options);
      this.querySelectorAll('[data-category-link]').forEach((link) => {
        link.addEventListener('click', (event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.selectCategory(link.dataset.categoryLink);
          this.updateCategoryUrl(true);
          this.form.scrollIntoView({ block: 'start' });
        }, options);
      });
      this.addEventListener('shopify:block:select', () => {
        this.form.reset();
        queueMicrotask(() => { this.refreshKinds(); this.applyFilters(); });
      }, options);
      this.refreshKinds();
      this.applyFilters();
      this.readCategoryUrl();
      window.addEventListener('hashchange', () => this.readCategoryUrl(), options);
      window.addEventListener('popstate', () => this.readCategoryUrl(), options);
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    selectCategory(category) {
      const fields = this.form.elements;
      fields.query.value = '';
      fields.category.value = category;
      fields.kind.value = '';
      fields.price.value = '';
      fields.stock.checked = false;
      this.refreshKinds();
      this.applyFilters();
    }
    readCategoryUrl() {
      const anchor = window.location.hash.slice(1);
      const category = anchor === 'balm' ? 'care' : anchor;
      if (!category || this.groups.some((group) => group.dataset.group === category)) this.selectCategory(category);
    }
    updateCategoryUrl(push = false) {
      const url = new URL(window.location.href);
      url.hash = this.form.elements.category.value;
      if (url.href === window.location.href) return;
      window.history[push ? 'pushState' : 'replaceState'](window.history.state, '', url.href);
    }
    normalize(value) { return value.normalize('NFKC').toLocaleLowerCase('ja').trim(); }
    matchesCard(card, filters) {
      const data = card.dataset;
      if (filters.category && data.category !== filters.category) return false;
      if (filters.kind && data.kind !== filters.kind) return false;
      if (filters.stock && data.stock !== 'true') return false;
      if (filters.price !== '') {
        if (data.preview === 'true' || data.price === '' || Number(data.price) > Number(filters.price)) return false;
      }
      const searchable = this.normalize(data.search);
      return this.normalize(filters.query).split(/\s+/u).filter(Boolean).every((word) => searchable.includes(word));
    }
    refreshKinds() {
      const selector = this.form.elements.kind;
      const previous = selector.value;
      const category = this.form.elements.category.value;
      while (selector.options.length > 1) selector.remove(1);
      const kinds = new Set(this.cards.filter((card) => !category || card.dataset.category === category).map((card) => card.dataset.kind));
      kinds.forEach((kind) => { if (kind) selector.add(new Option(kind, kind)); });
      selector.value = kinds.has(previous) ? previous : '';
    }
    applyFilters() {
      const fields = this.form.elements;
      const filters = { query: fields.query.value, category: fields.category.value, kind: fields.kind.value, stock: fields.stock.checked, price: fields.price.value };
      let count = 0;
      this.cards.forEach((card) => { card.hidden = !this.matchesCard(card, filters); if (!card.hidden) count += 1; });
      this.groups.forEach((group) => { group.hidden = !Array.from(group.querySelectorAll('[data-card]')).some((card) => !card.hidden); });
      this.querySelector('[data-count]').textContent = String(count);
      this.querySelector('[data-empty]').hidden = count > 0;
      this.querySelectorAll('[data-category-link]').forEach((link) => {
        if (link.dataset.categoryLink === filters.category) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
    }
  }
  customElements.define('cbd-product-finder', CbdProductFinder);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
